import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { ErrorText } from 'src/app/enums/error-text.enum';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'fury-add-edit-claim-question',
  templateUrl: './add-edit-claim-question.component.html',
  styleUrls: ['./add-edit-claim-question.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class AddEditClaimQuestionComponent implements OnInit {

  claimQuestionForm!: FormGroup;
  questionId: any;
  questionDetails: any;
  constructor(
    private apiService: ApiService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public location: Location
  ) {
    this.formInit();
    this.questionId = this.activatedRoute.snapshot.params["id"];
    // this.getAdditionalQuestion();
  }

  ngOnInit(): void {

  }

  formInit() {
    this.claimQuestionForm = new FormGroup({
      question: new FormControl('', [Validators.required, Validators.minLength(2)]),
      answers: new FormArray([]),
    });
    this.addAnswer();
  }

  get answersControl() {
    return this.claimQuestionForm.get('answers') as FormArray;
  }

  createAnswerGroup(): FormGroup {
    return new FormGroup({
      answer: new FormControl('', [Validators.required, Validators.minLength(2)]),
      isCovered: new FormControl(true, [Validators.required]),
    });
  }

  addAnswer() {
    this.answersControl.push(this.createAnswerGroup());
  }

  removeAnswer(index: number) {
    this.answersControl.removeAt(index);
  }


  addClaimQuestion() {
    if (this.claimQuestionForm.valid) {
      this.apiService.post('admin/claim/claim-question/create-claim-question', this.claimQuestionForm.value).subscribe((res: any) => {
        if (res) {
          this.apiService.alert(res?.body?.message, ErrorType.Success);
          this.location.back();
        }
      }, err => {
        if (err) {
          this.apiService.alert(err.message, ErrorType.Error);
        }
      })
    } else {
      this.claimQuestionForm.markAllAsTouched();
    }
  }


}
